import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import cz from './locales/cz.json';
import en from './locales/en.json';
import ro_MD from './locales/ro.json';
i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        cz: { translation: cz },
        "ro-MD": { translation: ro_MD },
    },
    lng: localStorage.getItem('lang') || 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
});
export default i18n;
